@if (isMobile() && !isProductOrContactPage() && !isLoading){
<div
  class="page-header"
  [ngClass]="{
    'px-lg-4': !class,
  }"
>
  <div [ngClass]="containerClasses()">
    @if(totalRegistros){
    <!-- Start::si hay registros -->
    @if (isBrandSearch()) {
    <!-- Start::Si fue filtrado por marca -->
    <div class="col-12 pt-1 me-1 textToSearch col-xs-12 textToSearchLocation">
      <div class="text-start">
        <div [style.font-size]="fontSize()">
          (<strong>{{ totalRegistros }}</strong
          >) Resultados en:
          <strong>{{ getBrandNameFromUrl() | titlecase }}</strong>
        </div>
      </div>
    </div>
    <!-- End::Si fue filtrado por marca -->
    } @else {
    <!-- Start::si no fue filtrado por marca -->
    <div class="col-12 pt-1 me-1 textToSearch col-xs-12 textToSearchLocation">
      <div class="text-center">
        <div [style.font-size]="fontSize()">
          (<strong>{{ totalRegistros }}</strong
          >) Resultados en:
          <span>{{ decodedUrl(textToSearch) }}</span>
          @if (categoryLabel) {
          <strong> {{ categoryLabel | titlecase }}</strong> }
        </div>
      </div>
    </div>
    <!-- End::si no fue filtrado por marca -->

    }
    <!-- End::si hay registros -->
    } @else {
    <!-- Start::mensaje que no hay resultados -->
    <!--<div
      class="col-12 pt-1 me-1 fw-bold textToSearch col-xs-12 textToSearchLocation"
    >
      <div class="container">
        <h5 class="text-center mt-2 text-secondary">
          Oops!... no se encontraron resultados!
          <i class="fa fa-exclamation-triangle"></i>
        </h5>
      </div>
    </div>-->
    }
    <!-- End::mensaje que no hay resultados -->
  </div>
</div>
}
